<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.4588 5.20994C11.7377 4.931 12.19 4.931 12.4689 5.20994C12.7332 5.47421 12.7471 5.89402 12.5107 6.17466L12.4689 6.22009L8.68808 10.0005L12.4683 13.7808C12.7326 14.045 12.7465 14.4648 12.5101 14.7455L12.4683 14.7909C12.2041 15.0552 11.7843 15.0691 11.5036 14.8326L11.4582 14.7909L7.17308 10.5058C6.90881 10.2415 6.8949 9.82173 7.13135 9.54109L7.17308 9.49566L11.4588 5.20994Z"
            fill="white"
        />
    </svg>
</template>
